import React, { useState, useEffect, useMemo, useRef } from 'react';
import cx from 'classnames';

import './Modal.css';

function Modal({ isShown, onClose, children }) {

  return (
    <div className={cx({ 'modal-base': true, 'modal-is-shown': isShown })}>
      <div className="modal-overlay" onClick={onClose} />

      <div className="modal-window">
        {children}
      </div>
    </div>
  );
}

export default Modal;
